import { render, staticRenderFns } from "./FeedbackWidget.vue?vue&type=template&id=0c34386e&scoped=true"
import script from "./FeedbackWidget.vue?vue&type=script&lang=js"
export * from "./FeedbackWidget.vue?vue&type=script&lang=js"
import style0 from "./FeedbackWidget.vue?vue&type=style&index=0&id=0c34386e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c34386e",
  null
  
)

export default component.exports